export const TRASHIE_BASE_URL = {
  development: 'http://localhost:3030',
  production: 'https://app.trashie.io',
  feature: 'https://app.feature.trashie.io',
  qa: 'https://app.qa.trashie.io',
  staging: 'https://app.staging.trashie.io',
  preview: /https:\/\/fd-swap-feature--(preview|feat|fix|refactor|hotfix)-(.*)\.web\.app/,
};

// Public API host (custom domain that fronts the cloud functions) — used for
// user-facing links the backend serves directly, e.g. the article share
// endpoint at `/v1/share/articles/<slug>` which handles OG tags + redirection.
// NOTE: distinct from REACT_APP_CLOUD_API_ENDPOINT (raw cloudfunctions.net host).
export const TRASHIE_API_URL = {
  development: 'https://api.qa.trashie.io',
  production: 'https://api.trashie.io',
  feature: 'https://api.staging.trashie.io',
  qa: 'https://api.qa.trashie.io',
  staging: 'https://api.staging.trashie.io',
};

export const getConfig = (key) => {
  const base = {
    WEB_URL: 'https://www.fordays.com',
    BASE_URL_TRASHIE: TRASHIE_BASE_URL.development,
    BASE_URL_TRASHIE_API: TRASHIE_API_URL.development,
    WEB_URL_TRASHIE: 'https://www.trashie.io',
    REACT_APP_FIREBASE_PUB_KEY: 'AIzaSyChjNp9tctkkZWX-QhNdOTVLCVQg6y8GDA',
    REACT_APP_FIREBASE_AUTH_DOMAIN: 'fd-swap-app-prod-1.firebaseapp.com',
    REACT_APP_FIREBASE_DATABASE_URL: 'https://fd-swap-app-prod-1.firebaseio.co',
    REACT_APP_FIREBASE_PROJECT_ID: 'fd-swap-app-prod-1',
    REACT_APP_FIREBASE_STORAGE_BUCKET: 'fd-swap-app-prod-1.appspot.com',
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID: '643780589845',
    REACT_APP_FIREBASE_APP_ID: '1:643780589845:web:1c30e6819054abe9e2111c',
    REACT_APP_SWAP_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api',
    // REACT_APP_SWAP_API_ENDPOINT: 'http://localhost:5000/fd-swap-app-prod-1/us-central1/api',
    REACT_APP_STORE_ID: '5280b4e0-5354-4e8e-9e4d-2bffee9e37f2',
    // REACT_APP_CLOUD_API_ENDPOINT: 'http://localhost:5001/fd-swap-app-prod-1/us-central1/api_dev',
    REACT_APP_CLOUD_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_v2',
  };

  const development = {
    ...base,
    REACT_APP_FIREBASE_AUTH_DOMAIN: TRASHIE_BASE_URL.staging.replace('https://', ''),
  };

  const feature = {
    ...base,
    BASE_URL_TRASHIE: TRASHIE_BASE_URL.feature,
    BASE_URL_TRASHIE_API: TRASHIE_API_URL.feature,
    REACT_APP_FIREBASE_AUTH_DOMAIN: TRASHIE_BASE_URL.feature.replace('https://', ''),
    REACT_APP_SWAP_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_qa',
    REACT_APP_CLOUD_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_qa',
  };

  const qa = {
    ...base,
    BASE_URL_TRASHIE: TRASHIE_BASE_URL.qa,
    BASE_URL_TRASHIE_API: TRASHIE_API_URL.qa,
    REACT_APP_FIREBASE_AUTH_DOMAIN: TRASHIE_BASE_URL.qa.replace('https://', ''),
    REACT_APP_SWAP_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_qa',
    REACT_APP_CLOUD_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_qa',
  };

  const staging = {
    ...base,
    BASE_URL_TRASHIE: TRASHIE_BASE_URL.staging,
    BASE_URL_TRASHIE_API: TRASHIE_API_URL.staging,
    REACT_APP_FIREBASE_AUTH_DOMAIN: TRASHIE_BASE_URL.staging.replace('https://', ''),
    REACT_APP_SWAP_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_staging',
    REACT_APP_CLOUD_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_staging',
  };

  if (process.env.REACT_APP_USE_LOCAL_CLOUD_API === 'true' && process.env.REACT_APP_ENV === 'staging') {
    staging.REACT_APP_CLOUD_API_ENDPOINT = 'http://127.0.0.1:5001/fd-swap-app-prod-1/us-central1/api_staging';
  }

  const production = {
    ...base,
    BASE_URL_TRASHIE: TRASHIE_BASE_URL.production,
    BASE_URL_TRASHIE_API: TRASHIE_API_URL.production,
    REACT_APP_FIREBASE_AUTH_DOMAIN: TRASHIE_BASE_URL.production.replace('https://', ''),
    REACT_APP_SWAP_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_v2',
    REACT_APP_CLOUD_API_ENDPOINT: 'https://us-central1-fd-swap-app-prod-1.cloudfunctions.net/api_v2',
  };

  const local = {
    ...base,
    BASE_URL_TRASHIE: TRASHIE_BASE_URL.development,
    BASE_URL_TRASHIE_API: TRASHIE_API_URL.qa,
    REACT_APP_FIREBASE_AUTH_DOMAIN: TRASHIE_BASE_URL.qa.replace('https://', ''),
    REACT_APP_SWAP_API_ENDPOINT: 'http://127.0.0.1:5001/fd-swap-app-prod-1/us-central1/api_staging',
    REACT_APP_CLOUD_API_ENDPOINT: 'http://127.0.0.1:5001/fd-swap-app-prod-1/us-central1/api_staging',
  };

  const configSettings = {
    development,
    feature,
    qa,
    staging,
    production,
    local,
  };

  const env = process.env.REACT_APP_ENV || 'production';

  const config = configSettings[env] || configSettings.development;
  if (!key) {
    return config;
  }

  return config[key];
};

export const isRecognizedTrashieHost = () => {
  const {
    location: { protocol, hostname, port },
  } = window;

  const currentLocation = `${protocol}//${hostname}${port ? `:${port}` : ''}`;

  return (
    currentLocation.match(TRASHIE_BASE_URL.preview) ||
    [
      TRASHIE_BASE_URL.development,
      TRASHIE_BASE_URL.feature,
      TRASHIE_BASE_URL.qa,
      TRASHIE_BASE_URL.staging,
      TRASHIE_BASE_URL.production,
    ].includes(currentLocation)
  );
};

export const isProd = () => process.env?.REACT_APP_ENV === 'production';
export const environmentSelected = process.env?.REACT_APP_ENV;

export default {
  getConfig,
  isRecognizedTrashieHost,
  isProd,
  environmentSelected,
};
